export default __webpack_public_path__ + "static/media/transp.d13feac1.gif";